export default __webpack_public_path__ + "static/media/before@3x.fd218b05.png";